import { createSlice } from "@reduxjs/toolkit";
import {
  addProcessorRamChannelKit,
  fetchProcessorRamChannelKitAttributes,
  fetchProcessorRamChannelKitById,
  updateProcessorRamChannelKit,
  updateStatusInProcessorRamChannelKit,
} from "./thunk";

interface CategoryState {
  processor_ram_channel_kit_list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedCategories: any;
}

const initialState: CategoryState = {
  processor_ram_channel_kit_list: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedCategories: null,
};

const categorySlice = createSlice({
  name: "processor_ram_channel_kit",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProcessorRamChannelKitAttributes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProcessorRamChannelKitAttributes.fulfilled, (state, action) => {
        state.loading = false;
        state.processor_ram_channel_kit_list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchProcessorRamChannelKitAttributes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch processor_cors";
      })
      .addCase(fetchProcessorRamChannelKitById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProcessorRamChannelKitById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedCategories = action.payload;
      })
      .addCase(fetchProcessorRamChannelKitById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(addProcessorRamChannelKit.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.processor_ram_channel_kit_list = state.processor_ram_channel_kit_list.map((processor_cors) =>
          processor_cors.id === action.payload.id ? action.payload : processor_cors
        );
      })
      .addCase(addProcessorRamChannelKit.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })
      .addCase(updateProcessorRamChannelKit.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.processor_ram_channel_kit_list = state.processor_ram_channel_kit_list.map((processor_cors) =>
          processor_cors.id === action.payload.id ? action.payload : processor_cors
        );
      })
      .addCase(updateProcessorRamChannelKit.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })
      .addCase(updateStatusInProcessorRamChannelKit.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        // state.categoryList = state.categoryList.map((category) =>
        //   category.id === action.payload.id ? action.payload : category
        // );
      })
      .addCase(updateStatusInProcessorRamChannelKit.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update status";
      });
  },
});

export default categorySlice.reducer;
